import * as React from "react";

function SettingsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: props.color || 'current',
    viewBox: "0 0 32 32",
    "aria-hidden": "true",
    width: props.width || '32px'
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || 'current',
    fillRule: "evenodd",
    d: "M19.773 2h-7.554l-1.022 4.108c-.48.23-.943.496-1.383.796L5.767 5.72l-3.783 6.556 3.047 2.95c-.018.254-.029.51-.03.766v.016c.001.256.012.512.03.767l-3.047 2.95 3.783 6.555 4.045-1.183c.427.293.875.555 1.34.783L12.228 30h7.544l1.077-4.112c.467-.23.917-.495 1.345-.792l4.082 1.17 3.78-6.552-3.06-2.964c.009-.255.01-.511.004-.767a12.12 12.12 0 00-.03-.758l3.046-2.95-3.782-6.555-4.045 1.183a10.598 10.598 0 00-1.34-.783L19.773 2zM25 16.008L26 16l-1 .026c.01.349 0 .698-.027 1.046l-.036.47 2.607 2.524-2.22 3.847-3.532-1.013-.4.306a8.601 8.601 0 01-1.792 1.058l-.444.194L18.228 28h-4.455l-.928-3.554-.448-.194a8.6 8.6 0 01-1.791-1.048l-.402-.306-3.49 1.022-2.218-3.844 2.623-2.54-.055-.488A10.11 10.11 0 017 16c.003-.35.025-.7.064-1.048l.055-.488-2.623-2.54L6.714 8.08 10.2 9.1l.401-.301a8.599 8.599 0 011.837-1.057l.461-.195L13.782 4h4.446l.928 3.554.447.194a8.598 8.598 0 011.792 1.048l.402.306 3.49-1.022 2.217 3.844-2.623 2.54.056.488c.04.35.06.703.063 1.056zM12 16a4 4 0 118 0 4 4 0 01-8 0zm4-6a6 6 0 100 12 6 6 0 000-12z",
    clipRule: "evenodd"
  }));
}

export default SettingsIcon;